// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-17W7a";
var _4 = "close-3knlX";
var _5 = "title-3Cq0X";
var _6 = "table-3r8zD";
var _7 = "row-1j3mi";
var _8 = "column-3FKoa";
var _9 = "tableHead-3NOsg";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "close", _5 as "title", _6 as "table", _7 as "row", _8 as "column", _9 as "tableHead" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "close": _4, "title": _5, "table": _6, "row": _7, "column": _8, "tableHead": _9 }
